const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const resolveServiceBase = (value: string) => {
  const normalized = trimTrailingSlash(value.trim());

  if (normalized.startsWith('http://') || normalized.startsWith('https://')) {
    return normalized;
  }

  if (normalized.startsWith('/')) {
    return normalized;
  }

  return `https://${normalized}`;
};
